import React from 'react';
import PrivacyPolicy from './PrivacyPolicy';

const TracsessPrivacyPolicy: React.FC = () => {
  return (
    <PrivacyPolicy
      appName="Tracsess"
      pdfUrl="https://tracess.s3.ap-south-1.amazonaws.com/documents/tracsess-user/Tracsess_Privacy_and_Cookie_Policy.pdf"
      title="Tracsess Privacy Policy & Cookie Policy"
    />
  );
};

export default TracsessPrivacyPolicy; 